import React, {useEffect, useState} from 'react';
import {FeatureDescriptionModal} from '../../../system/FeatureDescriptionModal';
import PulsoidClient from '../../../PulsoidClient';
import {SidebarAdvertisement} from '../../../PulsoidClient';

export const SidebarAdvertisementComponent = () => {
  const [descriptors, setDescriptors] = useState(
    null as SidebarAdvertisement[] | null
  );
  const [descriptor, setDescriptor] = useState(
    null as SidebarAdvertisement | null
  );

  const [modalOpened, setModalOpened] = useState(false);
  const [descriptorInterval, setDescriptorInterval] = useState(null as any);

  useEffect(() => {
    let descriptors: SidebarAdvertisement[] = [];
    const fetchDescriptor = async () => {
      descriptors = await new PulsoidClient().getSidebarAdvertisements();

      if (descriptors.length > 0) {
        setDescriptor(descriptors[0]);
      }
      setDescriptors(descriptors);
    };

    fetchDescriptor();
  }, []);

  useEffect(() => {
    if (modalOpened) {
      clearInterval(descriptorInterval);
    } else {
      if (descriptors != null && descriptors.length > 0) {
        let counter = 0;

        let id = setInterval(() => {
          counter = counter + 1;
          setDescriptor(descriptors[counter % descriptors.length]);
        }, 5000);

        setDescriptorInterval(id);
        return () => {
          clearInterval(id);
        };
      }
    }
  }, [modalOpened, descriptors]);

  if (descriptor) {
    if (descriptor.link) {
      return (
        <a
          href={descriptor.link}
          className="side-bar-entry"
          target="_blank"
          rel="noreferrer"
        >
          <img
            src={descriptor.imageUrl}
            alt="Advertisement"
            style={{width: '100%', height: '100%'}}
          />
        </a>
      );
    } else if (descriptor.featureDescriptionId) {
      return (
        <div
          className="side-bar-entry"
          onClick={() => {
            setModalOpened(!modalOpened);
          }}
        >
          <FeatureDescriptionModal
            id={descriptor.featureDescriptionId}
            controlled
            isOpen={modalOpened}
            onClose={() => {
              setModalOpened(false);
            }}
          />

          <img
            src={descriptor.imageUrl}
            alt="Advertisement"
            style={{width: '100%', height: '100%'}}
          />
        </div>
      );
    } else {
      return <div></div>;
    }
  } else {
    return <></>;
  }
};
